"use strict";

function getWatchList(callback) {

    var url = _config.watchListUrl.get;
    if(!url) {
        console.warn('_config.watchListUrl.get is not defined');
        return;
    }

    var data;
    $.ajax({
        url: url,
        dataType: 'json',
        success: function (response) {
            data = response;
            callback(data);
        },
        error: function () {}
    });
}

function setWatchlistCount(count) {
    if(count <= 0){
        $('.js-watchList-count').empty().closest('.js-watchList-link').removeClass('has-items');
    }else {
        $('.js-watchList-count').text(count).closest('.js-watchList-link').addClass('has-items');
    }
}

function watchListAdd(id, from, to, persons) {
    var url = _config.watchListUrl.add;
    if(!url) {
        console.warn('_config.watchListUrl.add is not defined');
        return;
    }

    $.ajax(url, {
        data: 'id=' + id + '&from=' + from + '&to=' + to + '&persons=' + persons,
        dataType: 'json',
        headers: {ajax: true}
    }).done(function (data) {
        if(data.success === true) {
            getWatchList(function(data) {
                setWatchlistCount(data.count)
            });
        }
    }).fail(function(a){
        console.warn(a);
    });
}

function watchListRemove(id, from, to, persons) {
    var url = _config.watchListUrl.remove;
    if(!url) {
        console.warn('_config.watchListUrl.remove is not defined');
        return;
    }

    $.ajax(url, {
        data: 'id=' + id + '&from=' + from + '&to=' + to + '&persons=' + persons,
        dataType: 'json',
        headers: {ajax: true}
    }).done(function (data) {
        if(data.success === true) {
            getWatchList(function(data) {
                setWatchlistCount(data.count)
            });
        }
    }).fail(function(a){
        console.warn(a);
    });
}
export function initInScope ($scope) {
    if(!_config.isLoggedIn) {
        return;
    }

    $scope.find('.js-watchList-btn').on('click', function (evt) {
        evt.preventDefault();
        evt.stopImmediatePropagation();

        if ($(this).hasClass('is-added')) {
            $(this).removeClass('is-added');
            watchListRemove($(this).data('id'), $(this).data('from'), $(this).data('to'), $(this).data('persons'));
        } else {
            $(this).addClass('is-added');
            watchListAdd($(this).data('id'), $(this).data('from'), $(this).data('to'), $(this).data('persons'));
        }

    });
}

export function getWatchListInfo($scope) {
    if(!_config.isLoggedIn) {
        return;
    }

    getWatchList(function(data) {
        var $addButtons = $scope.find('.js-watchList-btn');
        if ($addButtons && $addButtons.length) {
            $.each(data.items, function (type, id) {
                $addButtons.filter('[data-id="' + id + '"]').addClass('is-added');
            });
        }
        setWatchlistCount(data.count);
    });
}